import React from "react";
import CodeExample from "../../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { getRoles } from "../../crud/auth.crud";

import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from "@material-ui/core";      
 import { Link,Redirect } from "react-router-dom";
 import { IconButton } from '@material-ui/core';

export default class UserApproval extends React.Component {
  state = {
    roles:[]
  }
  componentDidMount()
  {
    
    getRoles().then(response => response.data)
    .then((data) => {
      this.setState({ roles: data })
      //console.log(this.state.users)
     })
  }
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <CodeExample beforeCodeTitle="Roles">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                     
                      <th>Role Code</th>
                      <th>Description</th>
                      <th>Edit</th>

                    </tr>
                  </thead>
                  <tbody>
                  {this.state.roles.map((role) => (
                    <tr>
                      
                      <td>{role.roleName}</td>
                      <td>{role.roleDescription}</td>
                      <td>
                         
                          <Link  to={{pathname:"/editrole", data: {role:role}}}>
                           <Tooltip
                                    title="Edit Role" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          
                      </td>
                    
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </CodeExample>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
